import React from 'react';
import Icon from '../../../components/AppIcon';

const TechnicalExpertise = () => {
  const skillCategories = [
    {
      category: 'Frontend Development',
      icon: 'Monitor',
      color: 'text-primary',
      skills: [
        { name: 'React/Next.js', level: 85, experience: '2+ years' },
        { name: 'TypeScript', level: 75, experience: '1+ years' },
        { name: 'JavaScript (ES6+)', level: 85, experience: '4.5+ years' },
        { name: 'HTML5/CSS3', level: 85, experience: '4.5+ years' },
        { name: 'Tailwind CSS', level: 80, experience: '4.5+ years' },
        { name: 'Bootstrap', level: 75, experience: '4.5+ years' },
        { name: 'Vue.js', level: 70, experience: '2+ years' }
      ]
    },
    {
      category: 'Backend Development',
      icon: 'Server',
      color: 'text-success',
      skills: [
        { name: 'Node.js/Express', level: 80, experience: '4.5+ years' },
        { name: 'PHP', level: 70, experience: '2+ years' },
        { name: 'REST APIs', level: 85, experience: '4.5+ years' },
        { name: 'EJS', level: 75, experience: '2+ years' },
        { name: 'Passport.js', level: 75, experience: '2+ years' },
        { name: 'ORM', level: 80, experience: '4.5+ years' },
        { name: 'RBAC', level: 75, experience: '2+ years' }
      ]
    },
    {
      category: 'Database & Storage',
      icon: 'Database',
      color: 'text-accent',
      skills: [
        { name: 'MongoDB', level: 80, experience: '4.5+ years' },
        { name: 'Mongoose', level: 75, experience: '4.5+ years' },
        { name: 'MySQL', level: 80, experience: '4.5+ years' },
        { name: 'Redis', level: 70, experience: '2+ years' }
      ]
    },
    {
      category: 'DevOps & Tools',
      icon: 'Wrench',
      color: 'text-warning',
      skills: [
        { name: 'Docker', level: 75, experience: '4.5+ years' },
        { name: 'Git/GitHub', level: 85, experience: '4.5+ years' },
        { name: 'Cloud Basics', level: 70, experience: '2+ years' },
        { name: 'CI/CD', level: 75, experience: '2+ years' }
      ]
    },
    {
      category: 'CMS & Others',
      icon: 'Globe',
      color: 'text-accent',
      skills: [
        { name: 'WordPress', level: 80, experience: '2+ years' },
        { name: 'CRM', level: 70, experience: '2+ years' }
      ]
    }
  ];

  const getSkillLevelColor = (level) => {
    if (level >= 90) return 'bg-success';
    if (level >= 80) return 'bg-primary';
    if (level >= 70) return 'bg-accent';
    return 'bg-warning';
  };

  const getSkillLevelText = (level) => {
    if (level >= 90) return 'Expert';
    if (level >= 80) return 'Advanced';
    if (level >= 70) return 'Intermediate';
    return 'Beginner';
  };

  return (
    <div className="bg-surface rounded-lg p-6 shadow-md border border-border">
      <div className="flex items-center mb-6">
        <Icon name="Code" size={24} className="text-primary mr-3" />
        <h2 className="text-2xl font-bold text-text-primary">Technical Expertise</h2>
      </div>

      <div className="space-y-8">
        {skillCategories.map((category, categoryIndex) => (
          <div key={categoryIndex}>
            {/* Category Header */}
            <div className="flex items-center mb-4">
              <div className={`w-10 h-10 rounded-lg bg-muted flex items-center justify-center mr-3`}>
                <Icon name={category.icon} size={20} className={category.color} />
              </div>
              <h3 className="text-lg font-semibold text-text-primary">{category.category}</h3>
            </div>

            {/* Skills Grid */}
            <div className="grid md:grid-cols-2 gap-4">
              {category.skills.map((skill, skillIndex) => (
                <div key={skillIndex} className="bg-muted rounded-lg p-4">
                  {/* Skill Header */}
                  <div className="flex items-center justify-between mb-2">
                    <div>
                      <h4 className="font-medium text-text-primary">{skill.name}</h4>
                      <p className="text-xs text-text-secondary">{skill.experience}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-sm font-medium text-text-primary">{skill.level}%</div>
                      <div className={`text-xs font-medium ${getSkillLevelColor(skill.level).replace('bg-', 'text-')}`}>
                        {getSkillLevelText(skill.level)}
                      </div>
                    </div>
                  </div>

                  {/* Progress Bar */}
                  <div className="w-full bg-border rounded-full h-2">
                    <div
                      className={`h-2 rounded-full transition-all duration-500 ${getSkillLevelColor(skill.level)}`}
                      style={{ width: `${skill.level}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Technical Certifications */}
      {/* <div className="mt-8 pt-6 border-t border-border">
        <div className="flex items-center mb-4">
          <Icon name="Award" size={20} className="text-primary mr-2" />
          <h3 className="text-lg font-semibold text-text-primary">Certifications & Training</h3>
        </div>
        
        <div className="grid md:grid-cols-2 gap-4">
          <div className="flex items-center p-3 bg-muted rounded-lg">
            <Icon name="CheckCircle" size={16} className="text-success mr-3" />
            <div>
              <div className="font-medium text-text-primary">MERN Stack Development</div>
              <div className="text-sm text-text-secondary">Iqonic Design • 2023</div>
            </div>
          </div>
          
          <div className="flex items-center p-3 bg-muted rounded-lg">
            <Icon name="CheckCircle" size={16} className="text-success mr-3" />
            <div>
              <div className="font-medium text-text-primary">React Fundamentals</div>
              <div className="text-sm text-text-secondary">Meta • 2022</div>
            </div>
          </div>
          
          <div className="flex items-center p-3 bg-muted rounded-lg">
            <Icon name="CheckCircle" size={16} className="text-success mr-3" />
            <div>
              <div className="font-medium text-text-primary">Docker Basics</div>
              <div className="text-sm text-text-secondary">Docker Inc • 2022</div>
            </div>
          </div>
          
          <div className="flex items-center p-3 bg-muted rounded-lg">
            <Icon name="CheckCircle" size={16} className="text-success mr-3" />
            <div>
              <div className="font-medium text-text-primary">WordPress Development</div>
              <div className="text-sm text-text-secondary">WordPress.org • 2023</div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default TechnicalExpertise;